var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAspectRatio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "aspect_ratio_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aspect_ratio_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.209 12.208H12.25a.526.526 0 00-.541.538.532.532 0 00.541.546h2.372a.65.65 0 00.478-.192.649.649 0 00.192-.478V10.25a.527.527 0 00-.537-.542.533.533 0 00-.388.156.519.519 0 00-.158.386v1.958zM5.792 7.792H7.75a.527.527 0 00.542-.538.532.532 0 00-.156-.387.519.519 0 00-.386-.159H5.38A.649.649 0 004.9 6.9a.649.649 0 00-.191.478V9.75a.527.527 0 00.537.542.532.532 0 00.387-.156.519.519 0 00.159-.386V7.792zm-2.035 7.791c-.375 0-.692-.13-.951-.388a1.295 1.295 0 01-.389-.952V5.75c0-.376.13-.692.389-.949s.576-.385.95-.385h12.488c.375 0 .692.13.951.389.26.259.389.576.389.951v8.492c0 .376-.13.692-.389.949a1.3 1.3 0 01-.951.385H3.757zm0-1.083h12.487a.245.245 0 00.176-.08.245.245 0 00.08-.176V5.756a.245.245 0 00-.08-.176.245.245 0 00-.176-.08H3.757a.245.245 0 00-.177.08.245.245 0 00-.08.176v8.488c0 .064.027.123.08.176.054.053.113.08.177.08z",
    fill: "#7A8D8F"
  }))));
}
export default SvgAspectRatio;